import { render } from "./BatchesPanel.vue?vue&type=template&id=3d24dd9d&scoped=true"
import script from "./BatchesPanel.vue?vue&type=script&lang=js"
export * from "./BatchesPanel.vue?vue&type=script&lang=js"

import "./BatchesPanel.vue?vue&type=style&index=0&id=3d24dd9d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d24dd9d"]])

export default __exports__